var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInsurance = function SvgInsurance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.791 4.1a.886.886 0 0 0-.886.794c-.292 2.851.455 8.415 5.723 10.877.235.11.51.11.744 0 5.268-2.462 6.015-8.026 5.724-10.877a.886.886 0 0 0-.887-.794H4.79Zm-.09.875c.004-.038.036-.075.09-.075H15.21c.054 0 .087.037.09.075.278 2.713-.456 7.823-5.266 10.07a.083.083 0 0 1-.066 0C5.157 12.799 4.423 7.689 4.7 4.976ZM10 5.75v8.5c-1.586-.81-4.703-3.643-4.49-8.5H10Z",
    fill: "currentColor"
  })));
};
export default SvgInsurance;